import React, { useEffect, useState } from 'react'
import './AdminTeamList.css'
import { NavLink } from 'react-router-dom'
import AdminButton from '../../shared/components/UIElements/AdminButton'
import AdminNavigation from './AdminNavigation'
import Modal from '../../shared/components/UIElements/Modal'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import { useHttpClient } from '../../shared/hooks/http-hook'

const AdminDropdownList = () => {
	const { sendRequest, clearError } = useHttpClient()
	const [showConfirmModal, setShowConfirmModal] = useState(false)
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [tournamentId, setTournamentId] = useState()
	const [loadedDropdownTournaments, setLoadedDropdownTournaments] = useState()
	const [tournamentDeleted, setTournamentDeleted] = useState()
	const [tournamentToDelete, setTournamentToDelete] = useState()
	//
	// This one is unique.  This function lets me add additional, NON PBHL or Non Rivals tournament
	//   links to my app's main dropdown.  Things like Future Stars and Cool Hockey
	//
	//First, lets tap into the following route on the backend to get all dropdown tournaments:
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + `/admin/dropdown`,
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedDropdownTournaments(responseData.allDropdownTournaments)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [tournamentDeleted])

	const errorHandler = () => {
		setError(null)
	}

	//******************************************************** */
	//
	//     Delete warning
	//
	//******************************************************** */

	const showDeleteWarningHandler = (e, tournamentName) => {
		const value = e.target.id
		console.log('tournament to delete: ' + tournamentName)
		setTournamentToDelete(tournamentName)
		setTournamentId(loadedDropdownTournaments[value]._id)
		setShowConfirmModal(true)
	}

	const cancelDeleteHandler = () => {
		setShowConfirmModal(false)
	}

	//console.log('league right here: ' + leagueId)
	const confirmDeleteHandler = async () => {
		setShowConfirmModal(false)
		try {
			await sendRequest(
				`${process.env.REACT_APP_BACKEND_URL}/admin/${tournamentId}/removeDropdownTournament`,
				'DELETE',
			)
		} catch (err) {}
		setTournamentDeleted(true)
	}

	return (
		<React.Fragment>
			<ErrorModal error={error} onClear={errorHandler} />
			{isLoading && (
				<div className='center'>
					<LoadingSpinner />
				</div>
			)}
			<Modal
				show={showConfirmModal}
				onCancel={cancelDeleteHandler}
				header='Are you sure?'
				footerClass='place-item__modal-actions'
				footer={
					<React.Fragment>
						<p className='modalText'>
							Are you sure you wish to delete <h1>{tournamentToDelete}</h1>
						</p>
						<br></br>
						<button
							className='cancelDeleteButtons buttonButton'
							inverse
							style={{ float: 'right' }}
							onClick={cancelDeleteHandler}
						>
							CANCEL
						</button>
						<button
							className='cancelDeleteButtons buttonButton'
							style={{ color: 'red' }}
							danger
							onClick={confirmDeleteHandler}
						>
							DELETE TOURNAMENT
						</button>
					</React.Fragment>
				}
			></Modal>
			{!isLoading && loadedDropdownTournaments && (
				<div className='Teams'>
					<AdminNavigation />
					<h1>Other Tournaments for the Dropdown</h1>
					<table id='venues' style={{ marginBottom: '6rem' }}>
						<thead>
							<tr>
								<th>Name</th>
								<th>Link</th>
								<th></th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							{loadedDropdownTournaments.map((tournament, key) => {
								return (
									<tr key={key}>
										<td>{tournament.tournamentName}</td>
										<td>{tournament.tournamentLink}</td>
										<td>
											<NavLink
												className='navlinks'
												to={`/admin/updateDropdownTournament/${tournament._id}`}
												exact
											>
												Edit
											</NavLink>
										</td>
										<td>
											<button
												className='buttonButton'
												style={{ color: 'red' }}
												id={key}
												onClick={(e) =>
													showDeleteWarningHandler(e, tournament.tournamentName)
												}
											>
												DELETE
											</button>
										</td>
									</tr>
								)
							})}
							{/* <tr style={{ backgroundColor: '#e0e0e0' }}>
								<AdminButton
									to={`/admin/dropdownTournament/new`}
									exact
									style={{
										color: 'white',
										textDecoration: 'none',
									}}
								>
									Add a new Tournament Link
								</AdminButton>
							</tr> */}
						</tbody>
						<div
							style={{
								width: '150%',
								marginTop: '2rem',
								marginBottom: '3rem',
								marginLeft: '1rem',
							}}
						>
							<AdminButton
								type='button'
								to={`/admin/dropdownTournament/new`}
								exact
							>
								Add New
							</AdminButton>
						</div>
					</table>
				</div>
			)}
		</React.Fragment>
	)
}

export default AdminDropdownList
